// extracted by mini-css-extract-plugin
export default {"collapseButtonWrapper":"styles_collapseButtonWrapper__uCtSV"};